import { render, staticRenderFns } from "./AddEditCompanyDetails.vue?vue&type=template&id=7c1d21c6"
import script from "./AddEditCompanyDetails.vue?vue&type=script&lang=js"
export * from "./AddEditCompanyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports